import React, { useContext } from 'react';
import ReactPlayer from 'react-player';

// components and helpers
import Explorers from './Explorers';
import videoImage from '../../assets/img/video_image.png';
import explorerBackground from '../../assets/img/ExplorerLibraryHeaderGraphic.svg';
import { AppContext } from '../../containers/AppProviderWrapper';

// mui
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ListItemAvatar, useTheme } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ListItemText from '@mui/material/ListItemText';

const DataLibrary: React.FC = () => {
    const { handleClickOpenContact, contactRef } = useContext(AppContext);
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down(900));
    const bulletPoints = [
        'Cancer Trials Explorer is a blockchain-enabled, user-friendly platform offering real-time data visualization and streamlined search for cancer studies aggregated from ClinicalTrials.gov.',
        'Providing researchers, healthcare providers, patients, and anyone seeking comprehensive cancer trial data for informed decision-making.',
        'Platform offers analytics for informed decision-making, supporting a wide range of stakeholders.',
    ];

    return (
        <Grid container justifyContent={'center'} spacing={4}>
            <Grid item xs={12}>
                <Grid
                    container
                    justifyContent={'center'}
                    alignItems={'center'}
                    style={{
                        backgroundImage: `url(${explorerBackground})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                        height: 300,
                    }}
                >
                    <Grid item xs={12}>
                        <Typography
                            variant="h5"
                            style={{
                                color: '#fff',
                                fontWeight: 'bold',
                                textAlign: 'center',
                            }}
                        >
                            EXPLORER LIBRARY
                        </Typography>
                    </Grid>
                    <Grid item xs={7}>
                        <Typography
                            variant={'body1'}
                            color={'#fff'}
                            style={{ textAlign: 'center' }}
                        >
                            The Health Data Explorer (HDE) team provides the
                            latest public health data from reputable sources,
                            including federal agencies. Our library offers a
                            comprehensive collection of current and accurate
                            datasets for your research, analysis, and
                            decision-making needs. Explore our data library to
                            stay informed and gain valuable insights into public
                            health trends and statistics.
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant={'contained'}
                            color={'inherit'}
                            style={{
                                borderRadius: 30,
                                fontWeight: 'bold',
                                color: '#325599',
                                backgroundColor: '#fff',
                                margin: '0 auto',
                                left: '50%',
                                transform: 'translateX(-50%)',
                            }}
                            onClick={handleClickOpenContact}
                            ref={contactRef}
                        >
                            Schedule a demo
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginTop: -15 }}>
                <Paper elevation={0} sx={{ p: 2 }}>
                    <Grid container spacing={3} alignItems={'center'}>
                        <Grid item xs={12} md={6}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography
                                        variant={'body2'}
                                        style={{ fontWeight: 'bold' }}
                                        color={'secondary'}
                                    >
                                        Featured Explorer
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography
                                        variant={'h5'}
                                        style={{ fontWeight: 'bold' }}
                                        color={'primary'}
                                    >
                                        Cancer Trials Explorer
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography>
                                        Acoer's Cancer Trial Explorer is a
                                        blockchain-enabled platform that
                                        provides real-time data visualization
                                        and streamlined search for cancer
                                        studies from ClinicalTrials.gov,
                                        offering easy access to reliable,
                                        up-to-date information for informed
                                        decision-making.
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <List>
                                        {bulletPoints.map(
                                            (value: string, index: number) => {
                                                return (
                                                    <ListItem
                                                        key={`homepage_bullet_${index}`}
                                                    >
                                                        <ListItemAvatar>
                                                            <CheckCircleIcon
                                                                color={
                                                                    'primary'
                                                                }
                                                            />
                                                        </ListItemAvatar>
                                                        <ListItemText
                                                            primary={
                                                                <Typography
                                                                    variant={
                                                                        'subtitle2'
                                                                    }
                                                                >
                                                                    {value}
                                                                </Typography>
                                                            }
                                                        />
                                                    </ListItem>
                                                );
                                            }
                                        )}
                                    </List>
                                </Grid>
                                <Grid item xs={12}>
                                    <a
                                        href={
                                            'https://cancertrials.acoer.com/dashboard'
                                        }
                                        target={'_blank'}
                                        rel="noreferrer"
                                    >
                                        <Button
                                            variant={'contained'}
                                            color={'primary'}
                                            style={{
                                                fontWeight: 'bold',
                                                borderRadius: 30,
                                            }}
                                        >
                                            View Dashboard
                                        </Button>
                                    </a>
                                    <a
                                        href="https://www.acoer.com/products/cancer-trials-explorer"
                                        target={'_blank'}
                                        rel="noreferrer"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        <Button
                                            variant={'outlined'}
                                            color={'primary'}
                                            style={{
                                                fontWeight: 'bold',
                                                borderRadius: 30,
                                                marginLeft: 5,
                                            }}
                                        >
                                            Learn More
                                        </Button>
                                    </a>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={6}
                            style={{ position: 'relative' }}
                        >
                            <ReactPlayer
                                url={'https://vimeo.com/960684509'}
                                light={videoImage}
                                controls={true}
                                style={{
                                    borderRadius: '50%',
                                    display: 'block',
                                    margin: 'auto',
                                    maxWidth: '100%',
                                    position: matches ? 'absolute' : 'relative',
                                }}
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <Explorers />
            </Grid>
        </Grid>
    );
};

export default DataLibrary;
